export default __webpack_public_path__ + "static/hero_updated-92102e8f84756e6f01bba99ec142f955.png";